import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { countries } from 'src/app/resources/countries';
import { SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Site } from 'src/app/models/site.model';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Team } from 'src/app/models/team.model';

@Component({
    selector: 'app-teams-form-component',
    templateUrl: './teams-form.component.html'
})
export class TeamsFormComponent extends DialogContentBase implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public countries = countries;
    public phoneNumberMask = '(+9) 0000-000-00-00';
    public fileRestrictions: FileRestrictions = {
        allowedExtensions: ['.png', '.jpeg', '.jpg']
    };
    public avatars?: NodeList;
    public listItems: Array<Site> = [];
    public formValue: Team = {
        id: 0,
        nome: '',
        refLocal: 0,
        nomeLocal: '',
        numeroDeFuncionarios: 0,
        traducoes: [
            { refLingua: 1, valor: '', descricaoLingua: '', id: 0 },
            { refLingua: 2, valor: '', descricaoLingua: '', id: 0 },
            { refLingua: 3, valor: '', descricaoLingua: '', id: 0 }
        ]
    };
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private notificationService: NotificationService, private api: ApiService, public override dialog: DialogRef) {
        super(dialog);
        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('selecionartag');
    }
    ngOnInit() {
        this.api
            .getRequest<BaseHttpResponse<Site[]>>("Local/GetLocais")
            .then((data) => {
                this.listItems = data.value;

            })
            .catch((err) => { });
    }
    public placeHolder: any = {
        nome: "",
        id: undefined,
    };

    public inputBlur() {
        if (this.formGroup.controls['en'].value == '' && this.formGroup.controls['fr'].value == '' && this.formValue.id == 0) {
            var texto = this.formGroup.controls['pt'].value;
            this.formGroup.controls['en'].setValue(texto);
            this.formGroup.controls['fr'].setValue(texto);
        }
    }
    public setFormValues() {
        var ptValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor;
        var enValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 2)[0].valor;
        var frValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 3)[0].valor;
        this.formGroup = new FormGroup({
            pt: new FormControl(ptValue, [Validators.required]),
            en: new FormControl(enValue, [Validators.required]),
            fr: new FormControl(frValue, [Validators.required]),
            site: new FormControl(this.formValue.refLocal != 0 ? this.formValue.refLocal : undefined, [Validators.required])

        });
    }

    public setAvatar() {
        this.avatars = document.querySelectorAll('.k-avatar .k-avatar-image');
        const avatarImg = localStorage.getItem('avatar');
        if (avatarImg) {
            this.avatars.forEach((avatar: any) => {
                avatar.style['background-image'] = `url("${avatarImg}")`;
            });
        }
    }

    public saveChanges(): void {
        this.formGroup.markAllAsTouched();
        this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor = this.formGroup.controls['pt'].value;
        this.formValue.traducoes.filter(_ling => _ling.refLingua === 2)[0].valor = this.formGroup.controls['en'].value;
        this.formValue.traducoes.filter(_ling => _ling.refLingua === 3)[0].valor = this.formGroup.controls['fr'].value;
        this.formValue.refLocal = this.formGroup.controls['site'].value
        this.api.save<BaseHttpResult>('Equipa/SaveEquipa', this.formValue).then(res => {
            if (res.ok) {
                this.notificationService.show({
                    content: this.customMsgService.translate('registoGravadoComSucesso'),
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'bottom' },
                    type: { style: 'success', icon: true },
                    hideAfter: 2000
                });
                this.dialog.close();
            } else {
                this.notificationService.show({
                    appendTo: this.container,
                    content: res.message,
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'top' },
                    type: { style: 'error', icon: true },
                    hideAfter: 4000
                });
            }
        });
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

    public isFileAllowed(file: any): boolean {
        return <boolean>this.fileRestrictions.allowedExtensions?.includes(file.extension);
    }

    public selectAvatar(ev: SelectEvent): void {
        const avatars = this.avatars;
        const reader = new FileReader();
        const file = ev.files[0];
        if (file.rawFile && this.isFileAllowed(file)) {
            reader.onloadend = function () {
                avatars?.forEach((avatar: any) => {
                    avatar.style['background-image'] = `url("${this.result}")`;
                    localStorage.setItem('avatar', (<string>this.result).toString());
                });
            };
            reader.readAsDataURL(file.rawFile);
        }
    }
}
